import React from 'react';
import { IPageTitle } from './interfaces';
import { Box, Typography } from '@mui/material';

export const PageTitle: React.FC<IPageTitle> = ({
  title,
  subTitle,
  children,
  sx,
  space = false,
}): JSX.Element => {
  const marginBottom = ((): string | undefined => {
    if (space === true) {
      return '10px';
    } else if (space === 'double') {
      return '20px';
    }

    return undefined;
  })();

  return (
    <Box
      sx={{
        mb: marginBottom,
        ...sx,
      }}
    >
      <Box>
        <Typography variant="h1">{title}</Typography>
        {subTitle && (
          <Typography variant="body2" color="#9E9E9E">
            {subTitle}
          </Typography>
        )}
      </Box>
      {children}
    </Box>
  );
};
